import { render, staticRenderFns } from "./virus19ranking.vue?vue&type=template&id=17a1c41c&scoped=true&"
import script from "./virus19ranking.vue?vue&type=script&lang=js&"
export * from "./virus19ranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1c41c",
  null
  
)

export default component.exports